/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboundDocumentCounts
 */
export interface InboundDocumentCounts {
    /**
     * 
     */
    NEEDS_TRIAGE: number;
    /**
     * 
     */
    ORDERS: number;
    /**
     * 
     */
    AUTH: number;
    /**
     * 
     */
    PRESCRIPTION: number;
    /**
     * 
     */
    JUNK: number;
    /**
     * 
     */
    OTHER: number;
}

/**
 * Check if a given object implements the InboundDocumentCounts interface.
 */
export function instanceOfInboundDocumentCounts(value: object): value is InboundDocumentCounts {
    if (!('NEEDS_TRIAGE' in value) || value['NEEDS_TRIAGE'] === undefined) return false;
    if (!('ORDERS' in value) || value['ORDERS'] === undefined) return false;
    if (!('AUTH' in value) || value['AUTH'] === undefined) return false;
    if (!('PRESCRIPTION' in value) || value['PRESCRIPTION'] === undefined) return false;
    if (!('JUNK' in value) || value['JUNK'] === undefined) return false;
    if (!('OTHER' in value) || value['OTHER'] === undefined) return false;
    return true;
}

export function InboundDocumentCountsFromJSON(json: any): InboundDocumentCounts {
    return InboundDocumentCountsFromJSONTyped(json, false);
}

export function InboundDocumentCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundDocumentCounts {
    if (json == null) {
        return json;
    }
    return {
        
        'NEEDS_TRIAGE': json['NEEDS_TRIAGE'],
        'ORDERS': json['ORDERS'],
        'AUTH': json['AUTH'],
        'PRESCRIPTION': json['PRESCRIPTION'],
        'JUNK': json['JUNK'],
        'OTHER': json['OTHER'],
    };
}

export function InboundDocumentCountsToJSON(json: any): InboundDocumentCounts {
    return InboundDocumentCountsToJSONTyped(json, false);
}

export function InboundDocumentCountsToJSONTyped(value?: InboundDocumentCounts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'NEEDS_TRIAGE': value['NEEDS_TRIAGE'],
        'ORDERS': value['ORDERS'],
        'AUTH': value['AUTH'],
        'PRESCRIPTION': value['PRESCRIPTION'],
        'JUNK': value['JUNK'],
        'OTHER': value['OTHER'],
    };
}

